import React from "react";
import PropTypes from 'prop-types';

const PaymentMethodList = ({ list, select }) => (
    list.length > 0 ?
        <ul className="list-group">{
            list.map(method =>
                <div className="card mt-2 fs-6" key={method.idPaymentMethod}>
                    <div className="card-body bg-primary bg-opacity-10">
                        <div className="d-flex flex-row justify-content-between flex-fill">
                            <div className="d-flex flex-column">
                                <h2 className="text-xl font-bold">{method.sourceName}</h2>
                                {
                                    method.accountType &&
                                    < h3 className="text-lg">Type: {method.accountType}</h3>
                                }
                                <h3 className="text-lg">Last 4: ****{method.last4}</h3>
                            </div>
                            <div className="d-flex flex-column gap-2">
                                {
                                    select &&
                                    <button className="btn btn-primary btn-sm" onClick={() => select(method.idPaymentMethod, false)}>Select</button>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            )
        }</ul > :
        `No payment methods yet. Add one above to see the list endpoint in action.`
);


PaymentMethodList.propTypes = {
    list: PropTypes.array.isRequired,
    select: PropTypes.func
};

export default PaymentMethodList;